import { createSlice } from "@reduxjs/toolkit"
import ratingApiSlice from "services/ratingService"
import appointmentApiSlice from "services/appointmentService"
import * as _ from "lodash"
import { apiUrl } from "helper/helper"
export const initialState = {
  ratings: {
    ids: [],
    ratings: {},
  },
}

const ratingSlice = createSlice({
  name: "ratings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      ratingApiSlice.endpoints.fetchAppointmentsRatingStatus.matchFulfilled,
      (state, action) => {
        const tempObj = {}
        action.payload.forEach((rating) => {
          if (rating) {
            tempObj[rating.appointmentid] = rating
            state.ratings.ids.push(rating.appointmentid)
          }
        })

        state.ratings.ratings = { ...state.ratings.ratings, ...tempObj }
      }
    )
    builder.addMatcher(
      ratingApiSlice.endpoints.fetchAppointmentsRatingStatus.matchRejected,
      (state, action) => {
        return initialState
      }
    )
    builder.addMatcher(
      appointmentApiSlice.endpoints.sendReviewMessage.matchFulfilled,
      (state, action) => {
        let index = state.ratings.ids.findIndex(
          (appointmentid) => appointmentid == action.payload.appointmentid
        )
        if (index == -1) {
          state.ratings.ids.push(action.payload.appointmentid)
          state.ratings.ratings[action.payload.appointmentid] = action.payload
        }
      }
    )
  },
})

export const selectRatingByAppointmentid = (state, appointmentid) =>
  state.ratings.ratings.ratings[appointmentid]

export default ratingSlice.reducer
export const { setPage, setDates, resetState } = ratingSlice.actions
